import config from "@/config";
/**
 * Statsig boolean gate for the Safe Mode feature.
 *
 * Read from two surfaces (the partner Integration toggle and the WABA-list
 * banner), so it lives here rather than as an inline literal. Production has no
 * BFF URL yet, so this gate is what keeps the feature invisible there.
 */
export var SAFE_MODE_GATE = "safe_mode";
/**
 * One dismissal key per scope, so dismissing on one surface never hides another.
 */
var dismissalKey = function (partnerId) {
    return "".concat(config.localStoragePrefixMP, ".SAFE_MODE_PAUSED_PARTNER.").concat(partnerId);
};
/**
 * Unavailable storage (private mode, quota, blocked cookies) counts as
 * DISMISSED. A storage failure must never make the banner nag on every page
 * view.
 */
export var isSafeModeBannerDismissed = function (partnerId) {
    if (!partnerId)
        return true;
    try {
        return sessionStorage.getItem(dismissalKey(partnerId)) === "true";
    }
    catch (error) {
        return true;
    }
};
export var dismissSafeModeBanner = function (partnerId) {
    if (!partnerId)
        return;
    try {
        sessionStorage.setItem(dismissalKey(partnerId), "true");
    }
    catch (error) {
        // Nothing to do - the banner is hidden for this render either way, and
        // treating unreadable storage as dismissed keeps it hidden afterwards.
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2FmZU1vZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzYWZlTW9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLE1BQU0sTUFBTSxVQUFVLENBQUM7QUFFOUI7Ozs7OztHQU1HO0FBQ0gsTUFBTSxDQUFDLElBQU0sY0FBYyxHQUFHLFdBQVcsQ0FBQztBQUUxQzs7R0FFRztBQUNILElBQU0sWUFBWSxHQUFHLFVBQUMsU0FBaUI7SUFDckMsT0FBQSxVQUFHLE1BQU0sQ0FBQyxvQkFBb0IsdUNBQTZCLFNBQVMsQ0FBRTtBQUF0RSxDQUFzRSxDQUFDO0FBRXpFOzs7O0dBSUc7QUFDSCxNQUFNLENBQUMsSUFBTSx5QkFBeUIsR0FBRyxVQUFDLFNBQWtCO0lBQzFELElBQUksQ0FBQyxTQUFTO1FBQUUsT0FBTyxJQUFJLENBQUM7SUFFNUIsSUFBSTtRQUNGLE9BQU8sY0FBYyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsU0FBUyxDQUFDLENBQUMsS0FBSyxNQUFNLENBQUM7S0FDbkU7SUFBQyxPQUFPLEtBQUssRUFBRTtRQUNkLE9BQU8sSUFBSSxDQUFDO0tBQ2I7QUFDSCxDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxxQkFBcUIsR0FBRyxVQUFDLFNBQWtCO0lBQ3RELElBQUksQ0FBQyxTQUFTO1FBQUUsT0FBTztJQUV2QixJQUFJO1FBQ0YsY0FBYyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsU0FBUyxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUM7S0FDekQ7SUFBQyxPQUFPLEtBQUssRUFBRTtRQUNkLHVFQUF1RTtRQUN2RSx1RUFBdUU7S0FDeEU7QUFDSCxDQUFDLENBQUMifQ==